import React from 'react';
import * as cls from './why-utilities-run-voltaware.module.css';
import { IMG_PATH } from '../../../../constants';
import { Section } from '../../../../ui/components/section';
import { Typography } from '../../../../ui/components/typography';

const items = [
  {
    title: 'Rapid deployment at scale',
    text: '5-minute, non-intrusive installs minimise truck-roll time and friction.',
  },
  {
    title: 'Engagement that sticks',
    text: 'Appliance-level insights drive measurable reductions in avoidable usage.',
  },
  {
    title: 'Targeting & evaluation',
    text: 'Identify high-impact cohorts (e.g., high standby, immersion heaters, EV) and quantify savings.',
  },
  {
    title: 'Flexible data delivery',
    text: 'Use Voltaware dashboards or pipe insights into your portals via APIs.',
  },
  {
    title: 'Works with or without smart meters',
    text: 'Add depth where smart - meter data exists; provide insights where it doesn’t.',
  },
];

export const WhyUtilitiesRunVoltaware = () => {
  return (
    <Section backgroundContrast classNameRoot={cls.section}>
      <Typography as="h1" tag="h2">
        Why Utilities Run Voltaware Pilots
      </Typography>

      <div className={cls.wrapper}>
        <ul className={cls.list}>
          {items.map((item, index) => (
            <li key={index}>
              <Typography>{item.title}</Typography>
              <Typography>{item.text}</Typography>
            </li>
          ))}
        </ul>
        <div>
          <img
            alt=""
            src={`${IMG_PATH}/our-technology/hardware/why-utilities-run-voltaware.png`}
          />
        </div>
      </div>
    </Section>
  );
};
